import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { projects } from "../../data/portfolioData";

const statusToColor = (s) => {
    if (s.toLowerCase().includes("active")) return "text-ink-green";
    if (s.toLowerCase().includes("progress")) return "text-ink-cyan";
    if (s.toLowerCase().includes("hackathon")) return "text-amber-300";
    if (s.toLowerCase().includes("research")) return "text-purple-300";
    return "text-[var(--ink-text-secondary)]";
};

const ProjectCard = ({ project, idx }) => {
    return (
        <a
            href={project.link}
            data-testid={`project-card-${project.id}`}
            className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-[var(--ink-border)] bg-[var(--ink-surface)] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-ink-cyan/30 hover:shadow-lg hover:shadow-black/50 md:p-7"
        >
            <div className="mb-5 flex items-start justify-between gap-4">
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-text-secondary)]">
                    {String(idx + 1).padStart(2, "0")} / {project.type}
                </span>
                <ArrowUpRight className="h-4 w-4 text-[var(--ink-text-secondary)] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink-cyan" />
            </div>

            <h3 className="text-lg font-medium leading-tight text-[var(--ink-text-primary)] transition-colors group-hover:text-ink-cyan md:text-xl">
                {project.title}
            </h3>

            <p className="mt-3 flex-1 text-sm leading-relaxed text-[var(--ink-text-secondary)]">
                {project.description}
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
                {project.stack.map((s) => (
                    <span
                        key={s}
                        className="rounded-md border border-[var(--ink-border)] bg-[var(--ink-bg)] px-2 py-1 font-mono text-[10px] text-[var(--ink-text-secondary)]"
                    >
                        {s}
                    </span>
                ))}
            </div>

            <div className="mt-6 flex items-center justify-between border-t border-[var(--ink-border)] pt-4">
                <span
                    className={`flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] ${statusToColor(
                        project.status,
                    )}`}
                >
                    <span className="inline-block h-1.5 w-1.5 rounded-full bg-current" />
                    {project.status}
                </span>
                <span className="font-mono text-[11px] text-[var(--ink-text-secondary)] transition-colors group-hover:text-ink-cyan">
                    view →
                </span>
            </div>
        </a>
    );
};

export const ProjectsSection = () => {
    return (
        <section
            id="projects"
            data-testid="projects-section"
            className="relative scroll-mt-24 px-6 py-24 md:px-12 md:py-32 lg:px-16"
        >
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    index="03"
                    kicker="Selected projects"
                    title="Things I’ve shipped, prototyped, or kept tinkering with."
                    subtitle="A mix of products, hackathon experiments, and research-y prototypes. Some are live, some are mid-rebuild."
                />

                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8 lg:grid-cols-3">
                    {projects.map((p, idx) => (
                        <ProjectCard key={p.id} project={p} idx={idx} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProjectsSection;
